import { LogEntryStatusListCombinedProps } from './types';

const usePresenter = (props: LogEntryStatusListCombinedProps): LogEntryStatusListCombinedProps => {
  return props;
};

export default usePresenter;
